<template>
  <section id="page-wrapper" class="page_personal-area">
    <TitleWithDatesFilter
      title="Личный кабинет"
      @on-save-dates="setDates"
    />
    <Tabs class="page__tabs">
      <Tab title="Общее" :with-height-limit="false">
        <div class="tab__blocks_first-level">
          <div class="blocks__group_small">
            <ProfileBlock class="group__block_profile" />
            <WorkShiftsBlock class="group__block_work-shifts" />
          </div>
          <ProjectsBlock class="blocks__block_projects" />
        </div>
        <AchievementsBlock
          class="tab__blocks_second-level"
          only-last-items
        />
        <MetricBlocks
          class="tab__blocks_third-level"
          :dates-range="dates"
        />
      </Tab>
      <Tab title="Все достижения" :with-height-limit="false">
        <AchievementsBlock />
      </Tab>
    </Tabs>
  </section>
</template>

<script>
import Tabs from '@/_shared/components/ui/Tabs';
import Tab from '@/_shared/components/ui/Tab';
import WorkShiftsBlock from '@/user/components/personal-area/WorkShiftsBlock';
import ProfileBlock from '@/user/components/personal-area/ProfileBlock';
import ProjectsBlock from '@/user/components/personal-area/ProjectsBlock';
import MetricBlocks from '@/user/components/personal-area/MetricBlocks';
import AchievementsBlock from '@/user/components/personal-area/AchievementsBlock';
import TitleWithDatesFilter from '@/user/features/personal-area/TitleWithDatesFilter';
export default {
  components: {
    Tabs,
    Tab,
    WorkShiftsBlock,
    ProfileBlock,
    ProjectsBlock,
    MetricBlocks,
    AchievementsBlock,
    TitleWithDatesFilter,
  },
  data() {
    return {
      dates: [],
    };
  },
  methods: {
    setDates(values) {
      this.dates = values;
    },
  },
};
</script>

<style scoped>
.page_personal-area {
  background-color: rgb(252, 252, 252) !important;
  padding-bottom: 2em !important;
  min-height: 100vh !important;
}
.tab__blocks_first-level {
  display: flex;
  flex-direction: row;
  column-gap: 1em;
}
.blocks__block_projects {
  width: 100%;
}
.tab__blocks_second-level {
  margin: 2em 0;
}
.tab__blocks_third-level {
  display: grid;
  grid-template-columns: repeat(3, auto);
  row-gap: 1.5em;
  column-gap: 1.5em;
}
.blocks__group_small {
  display: inline-flex;
  flex-direction: row;
  column-gap: 1em;
}
.group__block_work-shifts,
.group__block_profile {
  max-width: 300px;
  min-width: 300px;
}

@media (max-width: 1439px) {
  .tab__blocks_first-level {
    flex-direction: column;
    row-gap: 1em;
  }
  .group__block_work-shifts {
    width: 100%;
    max-width: 100%;
  }
}
@media (max-width: 1023px) {
  .tab__blocks_third-level {
    display: flex;
    flex-direction: column;
    row-gap: 1em;
  }
  .blocks__group_small {
    flex-direction: column;
    row-gap: 1em;
  }
  .group__block_profile {
    background: transparent;
    box-shadow: none !important;
    margin: 0 auto;
  }
}
@media (max-width: 767px) {
  .page__tabs {
    padding-top: 1.5em;
  }
}
</style>



// WEBPACK FOOTER //
// src/user/pages/PersonalAreaPage.vue